const TitleSkeleton = () => {
  return (
    <div className="flex flex-col w-full gap-2.5">
      <div className="w-1/12 h-[30px] bg-gray-300 rounded-3xl" />
      <div className="w-1/6 h-[30px] bg-gray-300 rounded-3xl" />
      <div className="w-1/4 h-[30px] bg-gray-300 rounded-3xl" />
    </div>
  );
};

export default TitleSkeleton;
